import { render } from "./UserProfileSettings.vue?vue&type=template&id=bc8dab30&scoped=true"
import script from "./UserProfileSettings.vue?vue&type=script&lang=js"
export * from "./UserProfileSettings.vue?vue&type=script&lang=js"

import "./UserProfileSettings.vue?vue&type=style&index=0&id=bc8dab30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc8dab30"]])

export default __exports__